import * as React from "react";
import * as styles from "./styles";

interface IProps {
  type?: "normal" | "headline" | "subheading" | "subsubheading";
  color?: "normal" | "grey" | "black" | "red";
}

const Typography: React.FunctionComponent<IProps> = ({
  type,
  children,
  color
}) => (
  <div className={`${styles.text} ${styles[type]} ${styles.color[color]}`}>
    {children}
  </div>
);

Typography.defaultProps = {
  type: "normal",
  color: "normal"
};

export default Typography;
